const postWidth = {
  desktopSingle: 900,
  desktopStream: 614,
  mobileStream: 375,
}

const assetSize = {
  desktopSingle: 600,
  desktopStream: 614,
  mobileStream: 375,
}

const renderDisplayLayout = (display) => {
  switch (display) {
    case 'desktopSingle':
      return { width: postWidth.desktopSingle }
    case 'desktopStream':
      return { width: postWidth.desktopStream }
    case 'mobileStream':
      return { width: postWidth.mobileStream }
    default:
      return {}
  }
}

const baseAssetStyles = ({ maintainAspectRatio, display }) => ({
  flex: 'none',
  height: maintainAspectRatio ? 'initial' : assetSize[display],
  width: assetSize[display],
})

const baseStyles = ({ maintainAspectRatio, display }) => ({
  backgroundColor: '#ffffff',
  borderRadius: 2,
  ...renderDisplayLayout(display),
  '.kuiper-asset-base': {
    ...baseAssetStyles({ maintainAspectRatio, display }),
    '&.kuiper-placeholder': {
      backgroundColor: '#ffffff',
    },
  },
})

export { baseStyles, baseAssetStyles }
